import { lazyLoad } from 'utils/loadable';

export const SegmentPage = lazyLoad(
  () => import('./index'),
  module => module.default,
);
